import { t } from "@web-monorepo/i18n/macro";
import { getImageSrc } from "@web-monorepo/static-assets";
import { DescriptionSlide } from "src/pods/conundrums/components/DescriptionSlide";
import { ExpectationsSlide } from "src/pods/conundrums/components/ExpectationsSlide";
import { IntroSlide } from "src/pods/conundrums/components/IntroSlide";
import { OptionsSlide } from "src/pods/conundrums/components/OptionsSlide";
import { PairShareSlide } from "src/pods/conundrums/components/PairShareSlide";
import { ShareToStorySlide } from "src/pods/conundrums/components/ShareToStorySlide";
import { Slide } from "src/pods/conundrums/components/types";

const farmerImage = getImageSrc("toolkit/src/pods/conundrums/assets/dojosaurusFarmer.png");
const dojosaurusIntro = getImageSrc("toolkit/src/pods/conundrums/assets/dojosaurusIntro.png");
const mojoImage = getImageSrc("toolkit/src/pods/conundrums/assets/dojosaurusMojo.png");
const rangerImage = getImageSrc("toolkit/src/pods/conundrums/assets/dojosaurusRanger.png");

const getTitle = () => t`Dojosaurus Rex`;
const getDescription = () => t`Mojo and his friends have discovered a massive dinosaur on someone else's land!`;
const getQuestionText = () => t`Who does it belong to?`;

const getOption1Text = () => t`Mojo & friends`;
const getTwist1Text = () => t`Will donate the skeleton to a local museum`;
const Option1Icon = mojoImage;

const getOption2Text = () => t`The farmer`;
const getTwist2Text = () => t`Will use the money to support his family`;
const Option2Icon = farmerImage;

const getOption3Text = () => t`The park`;
const getTwist3Text = () => t`Will sell the skeleton to make entrance to the park free for everyone`;
const Option3Icon = rangerImage;

const activities: Slide[] = [
  IntroSlide(getTitle, getDescription, getQuestionText, dojosaurusIntro),
  ExpectationsSlide(),
  DescriptionSlide(
    () =>
      t`Mojo and his friends discover a massive Dinosaur skeleton. But half of it is in Yosemite National Park, and the other half is on Farmer Spike's land. Who should the dinosaur belong to?`,
    dojosaurusIntro,
  ),
  ...getOptionSlides(),
  PairShareSlide(
    () =>
      t`Did you like discussing with your classmates? Why?\nWas it hard? Why or why not?\nWhat else did you notice?`,
  ),
  ShareToStorySlide(
    () => t`Congrats on completing this Conundrum!`,
    () => t`Now that was an interesting question indeed.`,
    "https://static.classdojo.com/img/dojosaurusShare.png",
    () => t`Great discussion!`,
  ),
];
function getOptionSlides(): Slide[] {
  const slides: Slide[] = [];
  const base = 2;

  for (let i = 0; i < Math.pow(2, 3); i++) {
    slides.push(
      OptionsSlide(
        () => t`Who does the dinosaur belong to? Why?`,
        [
          {
            id: "mojo",
            option: getOption1Text,
            icon: Option1Icon,
            twist: { twist: getTwist1Text, showTwist: Math.floor(i / Math.pow(base, 0)) % base !== 0 },
          },
          {
            id: "farmer",
            option: getOption2Text,
            icon: Option2Icon,
            twist: { twist: getTwist2Text, showTwist: Math.floor(i / Math.pow(base, 1)) % base !== 0 },
          },
          {
            id: "park",
            option: getOption3Text,
            icon: Option3Icon,
            twist: { twist: getTwist3Text, showTwist: Math.floor(i / Math.pow(base, 2)) % base !== 0 },
          },
        ],
        undefined,
        () => t`The skeleton belongs to _____ because...`,
      ),
    );
  }
  return slides;
}

export default activities;
